/*
 * Venturi cart order limits, front of house.
 *
 * Stops a shopper going over the caps before the request is sent, so they get
 * a sentence instead of a silent refusal at checkout. The server-rendered
 * notice in snippets/vu-cart-limits.liquid is the backstop: the drawer
 * re-renders through Liquid on every cart change, so a cart that gets over the
 * line by any route this file does not see still shows the notice and still
 * has its checkout button disabled.
 *
 * Everything hangs off window.VU_CL, emitted once by sections/cart-drawer.liquid
 * (which the layout renders on every page). VU_CL.items is keyed by BOTH product
 * handle and variant id, so any add-to-cart surface can be resolved from
 * whichever it exposes -- the PDP form, the shop grid, the bundle tile, the
 * supply offer, the drawer recommendations -- with no per-button annotation.
 *
 * Listeners are CAPTURE phase on document. cart.js binds in bubble phase and
 * the quantity controls use inline onclick, which is target phase; capture beats
 * both regardless of script load order, and stopPropagation() there keeps the
 * event away from them.
 */
(function () {
  if (window.__vuCartLimitsBound) return;
  window.__vuCartLimitsBound = true;

  var CFG = window.VU_CL;
  if (!CFG || !CFG.items) return;

  function weightOf(key) {
    if (key === null || key === undefined) return null;
    return CFG.items[String(key)] || null;
  }

  /* Current cart, read from the drawer's server-rendered rows so it is never
     stale: cart.js replaces that markup from Liquid after every change. */
  function currentCart() {
    var out = { e: 0, c: 0, singles: {} };
    var rows = document.querySelectorAll('.cart-drawer__product[data-vu-handle]');
    for (var i = 0; i < rows.length; i++) {
      var h = rows[i].getAttribute('data-vu-handle');
      var q = parseInt(rows[i].getAttribute('data-vu-qty'), 10) || 0;
      var w = weightOf(h);
      if (!w) continue;
      out.e += w.e * q;
      out.c += w.c * q;
      out.singles[h] = (out.singles[h] || 0) + q;
    }
    return out;
  }

  /* Bottles: one of each per order. Not in CFG.items (they weigh no boxes), so
     they are known by handle. The free-cart rule lives only in the Liquid
     notice; the checkout check below honours whatever that notice says. */
  var BOTTLE = CFG.bottlePrefix || 'venturi-bottle';
  var MSG_BOTTLE = CFG.msgSingle || '[title] is one per order.';
  function isBottle(h) { return !!h && h.indexOf(BOTTLE) === 0; }
  function bottleQty(h) {
    var n = 0;
    var rows = document.querySelectorAll('.cart-drawer__product[data-vu-handle]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-vu-handle') === h) n += parseInt(rows[i].getAttribute('data-vu-qty'), 10) || 0;
    }
    return n;
  }
  function bottleMsg(row) {
    var t = row && row.querySelector('.cart-drawer__product-title, h3, h4');
    return fmt(MSG_BOTTLE, { '[title]': t ? t.textContent.trim() : 'This bottle' });
  }
  function noticeText() {
    var n = document.querySelector('.cart-drawer .vu-cl-notice p, .vcart .vu-cl-notice p, .vu-cl-notice p');
    return n ? n.textContent.trim() : null;
  }

  function fmt(s, pairs) {
    for (var k in pairs) s = s.split(k).join(pairs[k]);
    return s;
  }

  /* The one rule. Returns a sentence to show, or null when the cart is fine. */
  function violation(cart) {
    if (CFG.maxE > 0 && cart.e > CFG.maxE) {
      return fmt(CFG.msgE, { '[max]': CFG.maxE, '[count]': cart.e });
    }
    if (CFG.maxC > 0 && cart.c > CFG.maxC) {
      return fmt(CFG.msgC, { '[max]': CFG.maxC, '[count]': cart.c });
    }
    for (var i = 0; i < CFG.singles.length; i++) {
      var h = CFG.singles[i];
      if ((cart.singles[h] || 0) > 1) {
        var w = weightOf(h);
        return fmt(CFG.msgSingle, { '[title]': (w && w.t) || h });
      }
    }
    return null;
  }

  /* Cart as it would be if `units` more of `handle` went in. */
  function withAdded(handle, units) {
    var cart = currentCart();
    var w = weightOf(handle);
    if (!w || units <= 0) return cart;
    cart.e += w.e * units;
    cart.c += w.c * units;
    cart.singles[w.h] = (cart.singles[w.h] || 0) + units;
    return cart;
  }

  /* Cart as it would be if the row for `handle` were set to `units`. */
  function withRowSetTo(handle, oldUnits, units) {
    var cart = currentCart();
    var w = weightOf(handle);
    if (!w) return cart;
    var d = units - oldUnits;
    cart.e += w.e * d;
    cart.c += w.c * d;
    cart.singles[w.h] = (cart.singles[w.h] || 0) + d;
    return cart;
  }

  /* Say it where the shopper is looking: under the buy button on a product
     page, the way cart.js already reports an add-to-cart failure; a toast
     everywhere else. */
  var toastTimer = null;
  function say(msg, el) {
    var form = el && el.closest && el.closest('.single-product__form');
    if (form) {
      var p = form.querySelector('.vu-atc-error');
      if (!p) {
        p = document.createElement('p');
        p.className = 'vu-atc-error';
        p.style.cssText = 'color:#c0392b;font-size:13px;margin-top:10px;';
        form.appendChild(p);
      }
      p.textContent = msg;
      return;
    }
    var t = document.getElementById('vu-cl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'vu-cl-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;max-width:min(420px,calc(100vw - 32px));background:#000;color:#fff;padding:12px 16px;border-radius:6px;font-size:13px;line-height:140%;text-align:center;box-shadow:0 6px 24px rgba(0,0,0,.25);';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.display = 'none'; }, 5000);
  }

  function block(e, msg, el) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    say(msg, el);
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    /* Checkout, both surfaces. The button is already disabled server-side when
       the cart is over; this catches a click that lands before a re-render. */
    var co = el.closest('.cart-drawer__checkout-btn, .vcart__checkout-btn, #checkout');
    if (co) {
      var v = violation(currentCart()) || noticeText();
      if (v) return block(e, v, co);
      return;
    }

    /* Product page add to cart. */
    var atc = el.closest('.atc-btn');
    if (atc) {
      var form = atc.closest('.single-product__form');
      var handle = atc.getAttribute('data-vu-handle');
      if (isBottle(handle) && bottleQty(handle) >= 1) return block(e, fmt(MSG_BOTTLE, { '[title]': 'This bottle' }), atc);
      var qtyEl = form && form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;
      var v2 = violation(withAdded(handle, qty));
      if (v2) return block(e, v2, atc);
      return;
    }

    /* Every one-click add: shop grid, bundle tile, supply offer, drawer
       recommendations. All of them call addToCartDrawer() with quantity 1. */
    var quick = el.closest('[data-variant-id][onclick]');
    if (quick) {
      var v3 = violation(withAdded(quick.getAttribute('data-variant-id'), 1));
      if (v3) return block(e, v3, quick);
      return;
    }

    /* Drawer plus button. */
    var plus = el.closest('.quan-plus');
    if (plus) {
      var row = plus.closest('.cart-drawer__product[data-vu-handle]');
      if (!row) return;
      var h = row.getAttribute('data-vu-handle');
      var q0 = parseInt(row.getAttribute('data-vu-qty'), 10) || 0;
      if (isBottle(h) && q0 >= 1) return block(e, bottleMsg(row), plus);
      var v4 = violation(withRowSetTo(h, q0, q0 + 1));
      if (v4) return block(e, v4, plus);
    }
  }, true);

  /* Typed quantity in the drawer. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('quan-input')) return;
    var row = input.closest('.cart-drawer__product[data-vu-handle]');
    if (!row) return;
    var h = row.getAttribute('data-vu-handle');
    var q0 = parseInt(row.getAttribute('data-vu-qty'), 10) || 0;
    var q1 = parseInt(input.value, 10);
    if (isNaN(q1) || q1 < 0) return;
    if (isBottle(h) && q1 > 1) {
      input.value = q0;
      return block(e, bottleMsg(row), input);
    }
    var v = violation(withRowSetTo(h, q0, q1));
    if (v) {
      input.value = q0;
      return block(e, v, input);
    }
  }, true);

  /* Cart page: typed quantities go in with the form, not by AJAX. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('vcart__form')) return;
    var cart = { e: 0, c: 0, singles: {} };
    var rows = document.querySelectorAll('.cart-drawer__product[data-vu-handle]');
    var inputs = form.querySelectorAll('input[name="updates[]"]');
    /* The drawer and the page list the same lines in the same order, so the
       drawer supplies the weights and the page supplies the typed numbers. */
    for (var i = 0; i < rows.length; i++) {
      var w = weightOf(rows[i].getAttribute('data-vu-handle'));
      if (!w) continue;
      var q = inputs[i] ? parseInt(inputs[i].value, 10) : parseInt(rows[i].getAttribute('data-vu-qty'), 10);
      if (isNaN(q) || q < 0) q = 0;
      cart.e += w.e * q;
      cart.c += w.c * q;
      cart.singles[w.h] = (cart.singles[w.h] || 0) + q;
    }
    var v = violation(cart);
    if (v) return block(e, v, form);
  }, true);
})();
